import { IonIcon, IonText } from '@ionic/react';
import { imageOutline } from 'ionicons/icons';
import React from 'react';
import styled from 'styled-components';
import { t } from 'ttag';

const Title = styled(IonText)`
  font-size: 22px;
  margin-bottom: 8px;
`;

const Subtitle = styled(IonText)`
  font-size: 16px;
`;

const Icon = styled(IonIcon)`
  width: 180px;
  height: 180px;
`;

const Image = styled.img`
  margin: 16px 0;
  width: 180px;
  height: 180px;
`;

type Props = {
  name: string;
  date: string;
  location: string;
  imageUrl?: string;
  infoText?: string;
};

const EventHeader = ({ name, date, location, imageUrl, infoText }: Props) => (
  <>
    {imageUrl ? <Image src={imageUrl} alt={t`Event Icon`} /> : <Icon icon={imageOutline} />}
    {infoText && <p>{infoText}</p>}
    <Title>{name}</Title>
    <Subtitle>{date}</Subtitle>
    <Subtitle>{location}</Subtitle>
  </>
);

export default EventHeader;
